import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
interface SlideOpportunityProps {
  onContinue: () => void;
}
export function SlideOpportunity({
  onContinue
}: SlideOpportunityProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 1200);
    const t2 = setTimeout(() => setStage(2), 2400);
    const t3 = setTimeout(() => setStage(3), 3600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative" data-id="element-335">
      {/* Background */}
      <motion.div className="absolute inset-0 z-0" animate={{
      background: stage >= 2 ? 'radial-gradient(circle at 50% 40%, rgba(0, 212, 170, 0.08) 0%, rgba(22, 32, 54, 1) 70%)' : 'radial-gradient(circle at 50% 40%, rgba(30, 45, 74, 0.3) 0%, rgba(22, 32, 54, 1) 70%)'
    }} transition={{
      duration: 1.5
    }} data-id="element-336" />

      <div className="z-10 max-w-3xl w-full space-y-10" data-id="element-337">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-5xl md:text-6xl lg:text-7xl font-serif leading-tight text-white" data-id="element-338">
          But here's the thing
        </motion.h2>

        <div className="space-y-6" data-id="element-339">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: stage >= 1 ? 1 : 0
        }} transition={{
          duration: 0.8
        }} className="text-2xl md:text-3xl text-white/80 font-medium" data-id="element-340">
            Legacy brands are high-margin.
            <br data-id="element-341" />
            <span className="text-white/50" data-id="element-342">
              R&D is paid off. Manufacturing is optimized.
            </span>
          </motion.p>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: stage >= 2 ? 1 : 0
        }} transition={{
          duration: 0.8
        }} className="text-2xl md:text-3xl text-teal-400 font-medium" data-id="element-343">
            Even small improvements scale across billions in revenue.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: stage >= 3 ? 1 : 0,
        y: stage >= 3 ? 0 : 10
      }} transition={{
        duration: 0.5
      }} className="pt-8" data-id="element-344">
          <Button onClick={onContinue} data-id="element-345">Continue</Button>
        </motion.div>
      </div>
    </div>;
}